import React from "react";
import Icon from "@ant-design/icons";

const IconSwap = ({ className, onClickSwap }) => {
  return <Icon className={className} component={SwapSvg} onClick={onClickSwap} />;
};

export default IconSwap;

const SwapSvg = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.9997 2.6665L9.33301 5.33317H11.333V9.99984C11.333 10.7332 10.733 11.3332 9.99967 11.3332C9.26634 11.3332 8.66634 10.7332 8.66634 9.99984V5.33317C8.66634 3.85984 7.47301 2.6665 5.99967 2.6665C4.52634 2.6665 3.33301 3.85984 3.33301 5.33317V9.99984H1.33301L3.99967 12.6665L6.66634 9.99984H4.66634V5.33317C4.66634 4.59984 5.26634 3.99984 5.99967 3.99984C6.73301 3.99984 7.33301 4.59984 7.33301 5.33317V9.99984C7.33301 11.4732 8.52634 12.6665 9.99967 12.6665C11.473 12.6665 12.6663 11.4732 12.6663 9.99984V5.33317H14.6663L11.9997 2.6665Z"
      fill="var(--primary-color)"
    />
  </svg>
);
